// Styles for List/Show/Create/Edit elements

import FuseTheme from '../global/theme';

export const viewStyles = {
    actions: {zIndex: 2, display: 'inline-block', float: 'right'},
    avatar: {backgroundColor: '#6e6e6e', width: 40, height: 40, marginRight: 10, verticalAlign: 'bottom'},
    break: {display: 'block', width: '100%', height: 0, border: 'none', margin: 0},
    calendarInline: {
        display: 'inline'
    },
    calendarInput: {
        border: 'none',
        borderBottom: '1px solid rgba(33, 33, 33, 0.1)',
        fontFamily: 'Roboto',
        fontSize: 16,
        textTransform: 'uppercase',
        width: '100%',
        outline: 'none',
        padding: '3px 0 3px 0',
    },
    calendarTopMargin: {
        marginTop: 15
    },
    calendarInputLabel: {
        color: 'rgba(33, 33, 33, 0.3)',
        fontSize: 12,
    },
    chip: {display: 'inline-block', margin: '2px 4px 2px 0'},
    divider: {
        display: 'block',
        width: '100%',
        height: 1,
        backgroundColor: '#1478b9',
        border: 'none',
        margin: '1em 0 0.5em 0'
    },
    error: {
        color: FuseTheme.palette.accent1Color,
    },
    fieldDescription: {
        flex: '1 1 40%',
        display: 'inline-block',
        width: 'auto',
        height: '2em',
        fontSize: '12px',
        color: 'rgba(33,33,33,0.5)',
        verticalAlign: 'bottom',
    },
    fieldDescriptionTop: {
        display: 'block',
        width: 'auto',
        fontSize: '14px',
        color: 'rgba(33,33,33,0.5)',
        margin: 0,
        verticalAlign: 'bottom',
    },
    fieldTitle: {
        display: 'block',
        width: '100%',
        fontSize: '20px',
        fontWeight: '500',
        color: 'rgba(33,33,33,0.5)',
        margin: '1em 0 1em 0',
    },
    fieldHeader: {
        display: 'block',
        width: '100%',
        fontSize: '16px',
        fontWeight: 'bold',
        color: 'rgba(33,33,33,0.5)',
        margin: '2em 0 0 0',
    },
    fieldHeaderDescription: {
        fontSize: '12px',
        fontWeight: 'normal',
    },
    fieldInput: {
        display: 'block',
        width: '100%',
        fontSize: '14px',
        color: 'rgba(33,33,33,0.8)',
        margin: '0 0 2em 0',
    },
    fieldInstructions: {
        display: 'block',
        width: '100%',
        fontSize: '14px',
        fontWeight: 'bold',
        color: 'rgba(33,33,33,0.5)',
        margin: '2em 0 2em 0',
    },
    fieldLabel: {
        display: 'block',
        fontSize: '14px',
        color: 'rgba(33,33,33,0.5)',
        margin: '0 0 4px 0',
        verticalAlign: 'bottom',
    },
    fieldParagraph: {
        display: 'block',
        width: '100%',
        fontSize: '14px',
        color: 'rgba(33,33,33,0.5)',
        margin: '0 0 2em 0',
    },
    fieldLight: {color: 'rgba(0, 0, 0, 0.3)'},
    fieldMediumColor: {color: 'rgba(33,33,33,0.5)'},
    fieldLink: {color: '#1478b9', textDecoration: 'none', borderBottom: '1px dotted rgba(33,33,33,0.5)'},
    fieldMultiline: {
        fontSize: '14px',
        padding: '4px 4px 4px 2px',
    },
    fieldSubheader: {
        display: 'block',
        width: '100%',
        fontSize: '14px',
        fontWeight: 'bold',
        color: 'rgba(33,33,33,0.5)',
        margin: '1em 0 0 0',
    },
    fieldMedium: {flex: '0 1 50%', display: 'block', minWidth: 300, maxWidth: '100%', overflow: 'hidden'},
    fieldWide: {flex: '0 1 80%', display: 'block', minWidth: '80%', maxWidth: '100%', overflow: 'hidden'},
    fieldWrap: {
        whiteSpace: 'pre-wrap'
    },
    filterDescription: {
        display: 'block',
        width: 'auto',
        height: '2em',
        fontSize: '16px',
        color: 'rgba(33,33,33,0.5)',
        margin: '1em 0 0 16px',
    },
    filterHalf: {minWidth: '50%'},
    filterInline: {display: 'inline-block', fontSize: '16px', marginRight: 10},
    filterLeft: {fontSize: '16px', width: '100%', minWidth: '50%'},
    filterSelectSmall: {
        display: 'inline-block',
        width: 150,
        minWidth: 50,
        maxWidth: 150,
        marginTop: 0,
        marginRight: '1em',
        overflow: 'hidden'
    },
    filterThird: {minWidth: '33%'},
    hidden: {display: 'none'},
    marginBottom: {marginBottom: '1em'},
    marginLeft: {marginLeft: '1em'},
    marginRight: {marginRight: '1em'},
    marginTop: {marginTop: '1em'},
    noMargin: {margin: 0},
    noPaddingTop: {paddingTop: 0},
    paddingBottom: {paddingBottom: '1em'},
    row: {display: 'flex', justifyContent: 'space-between'},
    rowField: {flex: '0 1 30%', display: 'inline-block', margin: '0 1em 0 0', verticalAlign: 'top'},
    rowFieldHalf: {flex: '0 1 50%', display: 'inline-block', margin: '0 1em 0 0', verticalAlign: 'top'},
    rowShowField: {display: 'inline-block', width: 'auto', minWidth: 100, margin: '0 1em 0 0', verticalAlign: 'top'},
    rowShowFieldWide: {
        display: 'inline-block',
        width: 'auto',
        minWidth: 200,
        margin: '0 1em 0 0',
        verticalAlign: 'top'
    },
    selectInputSmall: {minWidth: 50, maxWidth: 150, marginTop: 0, marginRight: '1em'},
};



// WEBPACK FOOTER //
// ./src/Fuse/shared/styles-view.js